import styled from 'styled-components';

import { pxToRem } from 'utils/scss';

export const CardWrapper = styled.div`
  width: ${props => (props.corporate ? pxToRem('297px') : pxToRem('370px'))};
  /*  height: ${props => (props.corporate ? pxToRem('412px') : 'auto')}; */
  height: auto;
  overflow-x: ${props => (props.corporate ? 'auto' : 'none')};
  margin: ${pxToRem('48px')} auto;
  border-radius: ${pxToRem('16px')};
  border: solid ${pxToRem('1px')} ${({ theme }) => theme.colors.lightGray2};
  background-color: ${({ theme }) => theme.colors.white};
`;

export const IconElement = styled.div`
  background: url(${props => props.img});
  background-repeat: no-repeat;
  display: block;
  width: ${pxToRem('88px')};
  height: ${pxToRem('88px')};
  margin: ${pxToRem('40px')} auto;
  background-size: cover;
`;

export const CardText = styled.div`
  text-align: center;
  padding-bottom: ${props => (props.corporateSite ? pxToRem('16px') : '0')};
`;
export const CardTextGray = styled.div`
  color: ${({ theme }) => theme.colors.grayText};
  text-align: center;
  text-transform: uppercase;
`;

export const CardTextWrapper = styled.div`
  display: flex;
  flex-flow: column;
  gap: ${pxToRem('26px')};
`;

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 0 ${pxToRem('44px')};
  cursor: pointer;
`;

export const SitesContainer = styled.div`
  max-height: ${pxToRem('180px')};
  overflow: auto;
`;
